/** TruFin TruStake vaults — per-(validator, nonce) detail. Shared by
 *  TruStakeMATICv2 (`0xa43A7c62D56dF036C187E1966c03E2799d8987eD`) and
 *  TruStakePOL (`0xc10214cdE5d6754Ec1e2220362f2120142c8E5e8`) on
 *  chain 1, which expose an identical interface.
 *
 *  Withdrawals route through Polygon validator unbond; the natural
 *  request unit is `(validator, unbondNonce)`. No user-keyed
 *  enumeration storage exists on this contract — caller supplies the
 *  `(validator, nonce)` pairs captured at withdraw time. */
export const TruFinVaultAbi = [
  {
    name: 'withdrawals',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'address', name: 'validator' },
      { type: 'uint256', name: 'unbondNonce' },
    ],
    outputs: [
      { type: 'address', name: 'user' },
      { type: 'uint256', name: 'amount' },
    ],
  },
  {
    name: 'isClaimable',
    type: 'function',
    stateMutability: 'view',
    inputs: [
      { type: 'uint256', name: 'unbondNonce' },
      { type: 'address', name: 'validator' },
    ],
    outputs: [{ type: 'bool' }],
  },
] as const
